import React from "react";
import {
    CustomerItem,
    ImgContainer,
    CustomerOrderItem,
    CircleIcon,
    OrderLinesContainer,
    OrderLineItem,
    OrderLineImg,
    MenuItem,
    CustomerTracking,
    AccountCircleIcon,
} from "./OrdersStyles";
import { withRouter } from "react-router-dom";
import { connect } from "react-redux";
import {
    getOrderDetails,
    updateOrderLines,
} from "../../actions/ordersActions";
import { changeTile } from "../../actions/changeTile";
import {
    RootContainer,
    TitleContainer,
    Title,
    DownArrow,
    SummaryCardOuter,
    SummaryCardInner,
    SummaryCardContainer,
    FlexColumn,
    FlexRow,
    SubTitle,
    Text,
    PopoverRoot,
    PopoverDoneButton,
    InputContainer,
    InputText,
    InputSelect,
} from "../Styles/commonStyles";
import { Helmet } from "react-helmet";
import { history } from "../../commons/utils";
import orderIcon from "./../../assets/icons/order.svg";
import CalenderIcon from "./../../assets/icons/calenderGrey.svg";
import moment from "moment";
import { Popover } from "@material-ui/core";
let anchor = null;
const shipping_companies = ["FedEx", "UPS", "USPS", "OnTrac", "DHL", "UDS", 'DPD', 'Royal Mail', 'Canpar Express', 'ATS', 'Couriers Plus', 'Purolator', 'Canada Post', 'Loomis', 'Bestway'];

class OrderDetails extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            orderDetails: {
                userDetails: {},
                orderLines: [],
                orderSummary: {
                    shipping_address: "",
                    shipping_method:"",
                    payment_method:"",
                },
            },
            lineItemsTotal: 0,
            unfulfilledItems: 0,
            statusAnchorEl: null,
            selectedProduct: {},
            openStatusPopover: false,
            shippedAnchorEl: null,
            openShippedDialog: false,
            shipmentCompany: "",
            shipmentNo: "",
            userId:"",
        };
    }

    componentDidMount() {
        if (this.props.tile !== "ORDERS") {
            this.props.changeTile("ORDERS");
        }
        if (this.props.history.action === "POP") {
            this.props.changeTile("ORDERS");
        }
        let QueryParams = new URLSearchParams(this.props.location.search);
        let orderId = QueryParams.get("id");
        let userId = QueryParams.get("user_id");
        this.setState({userId});
        this.props.getOrderDetails(orderId, userId);
    }

    async componentDidUpdate() {
        if (this.state.orderDetails !== this.props.orderDetails) {
            await this.setState({
                orderDetails: this.props.orderDetails,
            });
            await this.computeLineItems();
        }
    }

    handleCustomerOrdersRedirect = () => {
        let redirect_uri = `/orders?custId=${this.state.orderDetails.orderSummary.user_id}`;
        history.push(redirect_uri);
    };

    handleCloseStatusPopover = async (status) => {
        await this.setState({
            statusAnchorEl: null,
            openStatusPopover: false,
        });

        if (status !== null) {
            if (status === "SHIPPED") {
                await this.setState({
                    shippedAnchorEl: anchor,
                    openShippedDialog: true,
                    shipmentCompany: "",
                    shipmentNo: "",
                });
            } else {
                let body = {
                    status: status,
                    lineItemsList: [
                        {
                            orderLineId: this.state.selectedProduct._id,
                            shippedQty: 0,
                        },
                    ],
                };
                this.props
                    .updateOrderLines(this.state.orderDetails.orderSummary.order_id, body)
                    .then((res) => {
                        this.props.getOrderDetails(
                            this.state.orderDetails.orderSummary.order_id, this.state.userId
                        );
                    })
                    .catch((err) => {
                        console.log(err);
                    });
            }
        }
    };

    handleCloseShippedPopover = (flag) => {
        if (flag === true) {
            if (this.state.shipmentCompany !== "" && this.state.shipmentNo !== "") {
                let body = {
                    status: "FULFILLED",
                    trackingUrl: this.generateTrackingUrl({
                        company: this.state.shipmentCompany,
                        no: this.state.shipmentNo,
                    }),
                    lineItemsList: [
                        {
                            orderLineId: this.state.selectedProduct._id,
                            shippedQty: this.state.selectedProduct.qty,
                        },
                    ],
                };
                this.props
                    .updateOrderLines(this.state.orderDetails.orderSummary.order_id, body)
                    .then((res) => {
                        this.props.getOrderDetails(
                            this.state.orderDetails.orderSummary.order_id, this.state.userId
                        );
                        this.setState({
                            shippedAnchorEl: null,
                            openShippedDialog: false,
                        });
                    })
                    .catch((err) => {
                        console.log(err);
                    });
            }
        } else {
            this.setState({
                shippedAnchorEl: null,
                openShippedDialog: false,
            });
        }
    };

    generateTrackingUrl = (item) => {
        switch (item.company) {
            case "FedEx":
                return `https://www.fedex.com/apps/fedextrack/?action=track&trackingnumber=${item.no}`;
            case "UPS":
                return `https://www.ups.com/WebTracking/processInputRequest?tracknum=${item.no}`;
            case "OnTrac":
                return `https://www.ontrac.com/trackingresults.asp?tracking_number=${item.no}`;
            case "USPS":
                return `https://tools.usps.com/go/TrackConfirmAction?tRef=fullpage&tLc=4&text28777=&tLabels=${item.no}`;
            case "DHL":
                return `https://www.dhl.com/en/express/tracking.html?AWB=${item.no}&brand=DHL`;
            case "UDS":
                return `https://www.uniteddeliveryservice.com/track/api/orderref/${item.no}`
            case "DPD":
                return `https://track.dpdlocal.co.uk/search?reference=${item.no}`;
            case "Royal Mail":
                return `https://www.royalmail.com/track-your-item?trackNumber=${item.no}`;
            case "Canpar Express":
                return `https://www.canpar.com/en/tracking/track.htm?barcode=${item.no}`;
            case "ATS":
                return `https://www.atshealthcare.ca/quickTrackResult?ship=${item.no}`;
            case "Couriers Plus":
                return `https://couriersplus.ca/track-package/${item.no}`;
            case "Purolator":
                return `https://www.purolator.com/en/shipping/tracker?pins=${item.no}`;
            case "Canada Post":
                return `https://www.canadapost-postescanada.ca/track-reperage/en/search?searchFor=${item.no}`;
            case "Loomis":
                return `https://www.loomisexpress.com/loomship/Track/TrackResults?t=WAYBILL&s=${item.no}`;
            case "Bestway":
                return `https://bestwayworldwide.com/track/${item.no}`;
            default:
                return item.no;
        }
    };

    handleStatusClick = async (event, product) => {
        if (product.status === "CANCELLED" || product.status === "RETURNED") return;

        event.persist();
        anchor = event.currentTarget;
        await this.setState({ selectedProduct: product });
        await this.setState({
            statusAnchorEl: anchor,
            openStatusPopover: true,
        });
    };

    handleBackClick = () => {
        history.push("/orders");
    };

    handleInputChange = (e, key) => {
        this.setState({
            [key]: e.target.value,
        });
    };

    computeLineItems = async () => {
        let fulfilled = 0;
        let totalItems = this.state.orderDetails.orderLines.length;
        await this.state.orderDetails.orderLines.forEach((item) => {
            if (item.status === "FULFILLED" || item.status === "RETURNED") {
                fulfilled += 1;
            }
        });
        this.setState({
            unfulfilledItems: totalItems - fulfilled,
            lineItemsTotal: totalItems,
        });
    };

    render() {
        let Address = [];
        if (this.state.orderDetails.orderSummary.shipping_address) {
            Address = this.state.orderDetails.orderSummary.shipping_address
                .split("||")
                .map((address, index) => {
                    return (
                        <p key={index} style={{ margin: "0" }}>
                            {address}
                        </p>
                    );
                });
        }

        let TrackingUrls = [];
        if (this.state.orderDetails.orderSummary.tracking_urls &&
            this.state.orderDetails.orderSummary.tracking_urls.length) {
            TrackingUrls = this.state.orderDetails.orderSummary.tracking_urls;
        }

        var formatDollar = new Intl.NumberFormat("en-US", {
            style: "currency",
            currency: "USD",
            minimumFractionDigits: 2,
        });

        const ShippingOptions = shipping_companies.map((item, index) => {
            return (
                <option key={index} value={item}>
                    {item}
                </option>
            );
        });

        const ShippedDialog = (
            <Popover
                id="shipped-popover"
                onClose={() => this.handleCloseShippedPopover(false)}
                open={this.state.openShippedDialog}
                anchorEl={this.state.shippedAnchorEl}
                anchorOrigin={{
                    vertical: "bottom",
                    horizontal: "left",
                }}
                transformOrigin={{
                    vertical: "top",
                    horizontal: "left",
                }}
                PaperProps={{
                    style: {
                        borderRadius: "10px",
                    },
                }}
            >
                <PopoverRoot style={{ margin: "0" }}>
                    <div style={{ margin: "1rem" }}>
                        <SubTitle>Shipped</SubTitle>
                        <InputContainer>
                            <InputSelect
                                required
                                value={this.state.shipmentCompany}
                                onChange={(e) => this.handleInputChange(e, "shipmentCompany")}
                            >
                                <option disabled defaultValue value="">
                                    Shipping Company
                                </option>
                                {ShippingOptions}
                            </InputSelect>
                        </InputContainer>
                        <InputContainer>
                            <InputText
                                placeholder="Shipping Tracking #"
                                value={this.state.shipmentNo}
                                onChange={(e) => this.handleInputChange(e, "shipmentNo")}
                            />
                        </InputContainer>
                    </div>
                    <PopoverDoneButton
                        onClick={() => this.handleCloseShippedPopover(true)}
                    >
                        Done
                    </PopoverDoneButton>
                </PopoverRoot>
            </Popover>
        );

        let OrderLineItems = this.state.orderDetails.orderLines.map(
            (item, index) => {
                return (
                    <OrderLineItem
                        key={index}
                        border={index === this.state.lineItemsTotal - 1}
                    >
                        <OrderLineImg src={item.image_url} />
                        <FlexColumn style={{ width: "30%", alignSelf: "center" }}>
                            <FlexRow>
                                <Text style={{ marginRight: "10px" }}>{item.name}</Text>
                            </FlexRow>
                            <FlexRow style={{ marginTop: "10px" }}>
                                <Text style={{ marginRight: "10px" }}>Item Id:</Text>
                                <Text>{item.supplier_product_id}</Text>
                            </FlexRow>
                        </FlexColumn>
                        <FlexColumn style={{ width: "10%", alignSelf: "center" }}>
                            <Text>Price</Text>
                            <Text style={{ color: "#FF6F00" }}>
                                {formatDollar.format(item.price)}
                            </Text>
                        </FlexColumn>
                        <FlexColumn style={{ width: "10%", alignSelf: "center" }}>
                            <Text>QTY</Text>
                            <Text style={{ color: "#FF6F00" }}>{item.qty}</Text>
                        </FlexColumn>
                        <FlexColumn
                            onClick={(e) => {
                                this.handleStatusClick(e, item);
                            }}
                            style={{
                                width: "15%",
                                alignSelf: "center",
                                cursor:
                                    item.status === "CANCELLED" || item.status === "RETURNED"
                                        ? "default"
                                        : "pointer",
                            }}
                        >
                            <FlexRow style={{ alignSelf: "center" }}>
                                <Text>{item.status}</Text>
                                <DownArrow
                                    style={{
                                        display:
                                            item.status === "CANCELLED" || item.status === "RETURNED"
                                                ? "none"
                                                : "",
                                    }}
                                    className="fa fa-angle-down"
                                />
                            </FlexRow>
                            <Text style={{ color: "#FF6F00" }}>{item.qty}</Text>
                        </FlexColumn>
                    </OrderLineItem>
                );
            }
        );

        const OrderStatusMenu = (
            <Popover
                id="status-popover"
                anchorEl={this.state.statusAnchorEl}
                open={this.state.openStatusPopover}
                onClose={() => this.handleCloseStatusPopover(null)}
                anchorOrigin={{
                    vertical: "bottom",
                    horizontal: "left",
                }}
                transformOrigin={{
                    vertical: "top",
                    horizontal: "left",
                }}
            >
                <MenuItem
                    style={{
                        borderBottom: "1px black solid",
                        display:
                            this.state.selectedProduct.status === "FULFILLED" ? "none" : "",
                    }}
                    onClick={() => this.handleCloseStatusPopover("SHIPPED")}
                >
                    Shipped
                </MenuItem>
                <MenuItem
                    style={{
                        display:
                            this.state.selectedProduct.status === "PENDING" ? "" : "none",
                    }}
                    onClick={() => this.handleCloseStatusPopover("PROCESSING")}
                >
                    Processing
                </MenuItem>
                <MenuItem
                    onClick={() => this.handleCloseStatusPopover("RETURNED")}
                    style={{
                        display:
                            this.state.selectedProduct.status === "FULFILLED" ? "" : "none",
                    }}
                >
                    Returned
                </MenuItem>
                <MenuItem onClick={() => this.handleCloseStatusPopover("CANCELLED")}>
                    Cancelled
                </MenuItem>
            </Popover>
        );

        return (
            <RootContainer>
                <Helmet>
                    <title>Seller Portal | Order</title>
                </Helmet>
                <TitleContainer>
                    <DownArrow
                        style={{
                            marginRight: "0.5rem",
                            fontSize: "35px",
                            alignSelf: "center",
                        }}
                        className="fa fa-angle-left"
                        onClick={this.handleBackClick}
                    />
                    <Title>Orders</Title>
                </TitleContainer>
                {OrderStatusMenu}
                {ShippedDialog}
                <SummaryCardContainer>
                    <FlexRow style={{ width: "100%", justifyContent: "space-between" }}>
                        <FlexColumn style={{ width: "70%" }}>
                            <SummaryCardOuter width="100%">
                                <SummaryCardInner>
                                    <FlexColumn>
                                        <FlexRow style={{ justifyContent: "space-between" }}>
                                            <FlexRow>
                                                <Text>Order Id: </Text>
                                                <Text style={{ color: "#FF6F00", marginLeft: "5px" }}>
                                                    {this.state.orderDetails.orderSummary.order_id}
                                                </Text>
                                            </FlexRow>
                                            <FlexRow style={{ marginLeft: "20px" }}>
                                                <img
                                                    alt="calender"
                                                    style={{
                                                        width: "16px",
                                                        height: "18px",
                                                        alignSelf: "center",
                                                        marginTop: "-2px",
                                                        marginRight: "5px",
                                                    }}
                                                    src={CalenderIcon}
                                                />
                                                <Text>
                                                    {moment(
                                                        this.state.orderDetails.orderSummary.order_date
                                                    ).format("Do MMMM YYYY [at] h:mm a")}
                                                </Text>
                                            </FlexRow>
                                        </FlexRow>
                                        <FlexRow style={{ marginTop: "10px", justifyContent: "space-between" }}>
                                            <FlexRow>
                                                <FlexRow>
                                                    <Text>Total: </Text>
                                                    <Text style={{ color: "#FF6F00", marginLeft: "5px" }}>
                                                        {this.state.lineItemsTotal}
                                                    </Text>
                                                </FlexRow>
                                                <FlexRow style={{ marginLeft: "20px" }}>
                                                    <CircleIcon
                                                        style={{
                                                            marginRight: "5px",
                                                        }}
                                                    ></CircleIcon>
                                                    <Text>Unfulfilled: </Text>
                                                    <Text style={{ color: "#FF6F00", marginLeft: "5px" }}>
                                                        {this.state.unfulfilledItems}
                                                    </Text>
                                                </FlexRow>
                                            </FlexRow>
                                            {this.state.orderDetails.orderSummary.shipping_method
                                            ? <FlexRow>
                                                    <Text>Shipping Method: </Text>
                                                    <Text style={{ color: "#FF6F00", marginLeft: "5px" }}>
                                                        {this.state.orderDetails.orderSummary.shipping_method}
                                                    </Text>
                                                </FlexRow>
                                            : null
                                            }
                                        </FlexRow>
                                        <OrderLinesContainer>{OrderLineItems}</OrderLinesContainer>
                                    </FlexColumn>
                                </SummaryCardInner>
                            </SummaryCardOuter>
                            <SummaryCardOuter width="100%" style={{"marginTop":"1rem"}}>
                                <SummaryCardInner>
                                    <FlexRow style={{justifyContent: "space-between" }}>
                                        <SubTitle>Payment Summary</SubTitle>
                                        {this.state.orderDetails.orderSummary.payment
                                        ? <FlexRow>
                                                <Text>Payment Method: </Text>
                                                <Text style={{ color: "#FF6F00", marginLeft: "5px" }}>
                                                    {this.state.orderDetails.orderSummary.payment}
                                                </Text>
                                            </FlexRow>
                                        : null
                                        }
                                    </FlexRow>
                                    <FlexRow
                                        style={{
                                            justifyContent: "space-between",
                                            paddingBottom: "10px",
                                        }}
                                    >
                                        <FlexRow>
                                            <Text style={{ marginRight: "10px" }}>Subtotal</Text>
                                            <Text style={{ color: "grey" }}>
                                                ( {this.state.orderDetails.orderSummary.no_of_products}{" "}
                                                items )
                                            </Text>
                                        </FlexRow>
                                        <Text>
                                            {formatDollar.format(
                                                this.state.orderDetails.orderSummary.sub_total
                                            )}
                                        </Text>
                                    </FlexRow>
                                    <FlexRow
                                        style={{
                                            justifyContent: "space-between",
                                            paddingBottom: "10px",
                                        }}
                                    >
                                        <FlexRow>
                                            <Text style={{ marginRight: "10px" }}>Delivery</Text>
                                        </FlexRow>
                                        <Text>
                                            {formatDollar.format(
                                                this.state.orderDetails.orderSummary.shipping_charge
                                            )}
                                        </Text>
                                    </FlexRow>
                                    <FlexRow
                                        style={{
                                            justifyContent: "space-between",
                                            borderBottom: "solid 1px lightgrey",
                                            paddingBottom: "10px",
                                        }}
                                    >
                                        <FlexRow>
                                            <Text style={{ marginRight: "10px" }}>Tax</Text>
                                            <Text style={{ color: "lightgrey" }}></Text>
                                        </FlexRow>
                                        <Text>
                                            {formatDollar.format(
                                                this.state.orderDetails.orderSummary.tax
                                            )}
                                        </Text>
                                    </FlexRow>
                                    <FlexRow
                                        style={{
                                            justifyContent: "space-between",
                                            paddingTop: "10px",
                                        }}
                                    >
                                        <FlexRow>
                                            <Text style={{ fontWeight: "500" }}>
                                                Total paid by customer
                                            </Text>
                                        </FlexRow>
                                        <Text style={{ color: "#FF6F00", fontWeight: "500" }}>
                                            {formatDollar.format(
                                                this.state.orderDetails.orderSummary.total
                                            )}
                                        </Text>
                                    </FlexRow>
                                </SummaryCardInner>
                            </SummaryCardOuter>
                        </FlexColumn>
                        <SummaryCardOuter
                            style={{
                                position: "sticky",
                                top: "30px",
                            }}
                            width="27%"
                            height="100%"
                        >
                            <SummaryCardInner>
                                <SubTitle style={{ marginBottom: "0", marginTop: "10px" }}>
                                    Customer
                                </SubTitle>
                                <CustomerItem>
                                    <AccountCircleIcon />
                                    <div style={{ display: "flex", flexDirection: "column" }}>
                                        <div>{this.state.orderDetails.userDetails.name}</div>
                                        <div>{this.state.orderDetails.userDetails.email}</div>
                                        <div>{this.state.orderDetails.userDetails.phone}</div>
                                    </div>
                                </CustomerItem>
                                <CustomerOrderItem onClick={this.handleCustomerOrdersRedirect}>
                                    <ImgContainer src={orderIcon} />
                                    <p style={{ alignSelf: "center" }}>
                                        {this.state.orderDetails.userDetails.orderCountByUser +
                                            " Orders"}
                                    </p>
                                </CustomerOrderItem>
                                <SubTitle style={{ marginBottom: "0", marginTop: "15px" }}>
                                    Shipping Address
                                </SubTitle>
                                <CustomerItem style={{ flexDirection: "column" }}>
                                    {Address}
                                </CustomerItem>

                                {TrackingUrls && TrackingUrls.length
                                ? <>
                                        <SubTitle style={{ marginBottom: "0", marginTop: "15px" }}>
                                            Tracking Links
                                        </SubTitle>
                                        <ul>
                                            {TrackingUrls.map((url, index)=>(
                                                <li>
                                                    <CustomerTracking href={url} style={{ flexDirection: "column" }}>
                                                        {`Link ${index+1}`}
                                                    </CustomerTracking>
                                                </li>
                                            ))}
                                        </ul>
                                    </>
                                : null}
                                
                            </SummaryCardInner>
                        </SummaryCardOuter>
                    </FlexRow>
                </SummaryCardContainer>
            </RootContainer>
        );
    }
}

const mapStateTpProps = (store) => {
    return {
        orderDetails: store.orders.order_details,
    };
};

export default withRouter(
    connect(mapStateTpProps, { getOrderDetails, changeTile, updateOrderLines })(
        OrderDetails
    )
);
